import type { JSX } from 'react'
import { ArrowRightLeft, UserCheck, UserX, Send, Inbox } from 'lucide-react'
import type { HandoffEvent } from './timeline.js'

function describe(e: HandoffEvent): { icon: JSX.Element; text: string; tone: string } {
  const name = e.agentName ?? 'an agent'
  switch (e.kind) {
    case 'requested':
      return { icon: <ArrowRightLeft className="h-3 w-3" />, text: 'Chat transferred from AI to agents', tone: 'text-slate-500' }
    case 'offered':
      return { icon: <Send className="h-3 w-3" />, text: `Chat request sent to ${name}`, tone: 'text-slate-500' }
    case 'accepted':
      return { icon: <UserCheck className="h-3 w-3" />, text: `${name} accepted the chat`, tone: 'text-emerald-600' }
    case 'no_response':
      return { icon: <UserX className="h-3 w-3" />, text: `${name} did not respond`, tone: 'text-amber-600' }
    case 'no_agent':
      return { icon: <Inbox className="h-3 w-3" />, text: 'No agent available — chat is in the queue', tone: 'text-amber-600' }
  }
}

export function HandoffDivider({ event }: { event: HandoffEvent }): JSX.Element {
  const { icon, text, tone } = describe(event)
  const time = new Date(event.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  return (
    <div className="my-2 flex items-center gap-2 px-4" role="separator" aria-label={text}>
      <div className="h-px flex-1 bg-gray-200" />
      <span className={`flex items-center gap-1.5 text-[11px] font-medium ${tone}`}>
        {icon}
        {text}
        <span className="font-normal text-gray-400">{time}</span>
      </span>
      <div className="h-px flex-1 bg-gray-200" />
    </div>
  )
}
